"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapNamespacedTranslations = mapNamespacedTranslations;
/**
 * Remaps translations with namespaces to have their values replaced by passed `mapper`.
 *
 * @param namespacedTranslations Translations with namespaces.
 * @param mapper Function applying transformation to translation values.
 * @returns Remapped translations.
 */

function mapNamespacedTranslations(namespacedTranslations, mapper) {
  return Object.fromEntries(Object.entries(namespacedTranslations).map(([namespace, translations]) => [namespace, mapper(translations, namespace)]));
}
